"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Addresses$ = exports.Addresses$outboundSchema = exports.Addresses$inboundSchema = void 0;
exports.addressesToJSON = addressesToJSON;
exports.addressesFromJSON = addressesFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const royalmailformat_js_1 = require("./royalmailformat.js");
const simplifiedformat_js_1 = require("./simplifiedformat.js");
const streetgroupformat_js_1 = require("./streetgroupformat.js");
/** @internal */
exports.Addresses$inboundSchema = z.object({
    is_none_residential: z.boolean(),
    royal_mail_format: royalmailformat_js_1.RoyalMailFormat$inboundSchema,
    simplified_format: simplifiedformat_js_1.SimplifiedFormat$inboundSchema,
    street_group_format: streetgroupformat_js_1.StreetGroupFormat$inboundSchema,
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "is_none_residential": "isNoneResidential",
        "royal_mail_format": "royalMailFormat",
        "simplified_format": "simplifiedFormat",
        "street_group_format": "streetGroupFormat",
    });
});
/** @internal */
exports.Addresses$outboundSchema = z.object({
    isNoneResidential: z.boolean(),
    royalMailFormat: royalmailformat_js_1.RoyalMailFormat$outboundSchema,
    simplifiedFormat: simplifiedformat_js_1.SimplifiedFormat$outboundSchema,
    streetGroupFormat: streetgroupformat_js_1.StreetGroupFormat$outboundSchema,
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        isNoneResidential: "is_none_residential",
        royalMailFormat: "royal_mail_format",
        simplifiedFormat: "simplified_format",
        streetGroupFormat: "street_group_format",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var Addresses$;
(function (Addresses$) {
    /** @deprecated use `Addresses$inboundSchema` instead. */
    Addresses$.inboundSchema = exports.Addresses$inboundSchema;
    /** @deprecated use `Addresses$outboundSchema` instead. */
    Addresses$.outboundSchema = exports.Addresses$outboundSchema;
})(Addresses$ || (exports.Addresses$ = Addresses$ = {}));
function addressesToJSON(addresses) {
    return JSON.stringify(exports.Addresses$outboundSchema.parse(addresses));
}
function addressesFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.Addresses$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Addresses' from JSON`);
}
//# sourceMappingURL=addresses.js.map